import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/everpay.png'
import _imports_1 from '../../images/everpay-small.svg'
import _imports_2 from '../../images/languages.svg'


const _withScopeId = n => (_pushScopeId("data-v-370518d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full flex flex-row items-center justify-between w-full" }
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-7 hidden lg:block",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "block lg:hidden",
  src: _imports_1
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "ml-2 text-xs text-everGray3"
}
const _hoisted_6 = { class: "flex-row items-center justify-start h-full hidden relative lg:flex flex-1" }
const _hoisted_7 = ["target", "href"]
const _hoisted_8 = { class: "flex flex-row items-center justify-end h-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "languages"
  })
], -1))
const _hoisted_10 = {
  key: 0,
  class: "absolute bg-white p-2 w-max z-40 rounded-lg lang-dropdown -left-9",
  style: {"top":"60px"}
}
const _hoisted_11 = { class: "" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-black bg-opacity-0.15 h-4 w-px sm:mr-4 mr-3.5" })
], -1))
const _hoisted_14 = { class: "flex items-center justify-center relative" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "bg-white py-4 text-black text-opacity-0.85 md:w-80 w-264px h-screen right-0 fixed top-16 z-40 overflow-y-auto pb-36" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-black border-opacity-6 mb-1.5" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PcNavItem = _resolveComponent("PcNavItem")!
  const _component_MobileNavItem = _resolveComponent("MobileNavItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed px-4 z-20 top-0 left-0 w-full h-16 flex items-center justify-center delay-300 transition-shadow bg-transparent", `${_ctx.scrollTop > 0 ? 'frosted-glass' : ''}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        href: _ctx.everpayOfficialWebsiteHost,
        target: !_ctx.isMobile && _ctx.isEverpayApp ? '_blank' : '',
        class: "h-7 flex flex-row items-center"
      }, [
        _hoisted_3,
        _hoisted_4,
        (!_ctx.isProd)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Testnet"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(["border-l border-everGray1 h-4 mr-4 hidden lg:flex", _ctx.isProd ? 'ml-6' : ' ml-4'])
      }, null, 2),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pcNavItems, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "mr-8 last:mr-0 whitespace-nowrap"
          }, [
            (item.openNew && !item.items.length)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  target: !_ctx.isMobile && item.to ? '_blank' : '',
                  href: item.to ? item.to : 'javascript:void(0);',
                  class: _normalizeClass(["text-base text-everBlack2 transition-colors", _ctx.navbarTextColorHoverClass])
                }, _toDisplayString(_ctx.t(item.title)), 11, _hoisted_7))
              : (item.to && !item.items.length)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.to,
                    class: _normalizeClass(["text-base transition-colors", `${_ctx.navbarTextColorHoverClass} text-everBlack2`])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t(item.title)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                : (_openBlock(), _createBlock(_component_PcNavItem, {
                    key: 2,
                    items: item.items,
                    title: item.title,
                    "others-app-url": _ctx.othersAppUrl,
                    to: item.to
                  }, null, 8, ["items", "title", "others-app-url", "to"]))
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(["lang-wrapper text-14px relative h-full text-black flex-row flex items-center justify-center cursor-pointer", ` ${_ctx.navbarTextColorHoverClass} sm:mr-3.5 mr-2.5`]),
          onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.languagesHandleMouseOver && _ctx.languagesHandleMouseOver(...args))),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.languagesVisible = false))
        }, [
          _hoisted_9,
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.languagesVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (langItem) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: langItem.value,
                          class: _normalizeClass(["px-8 flex flex-row rounded-md items-center justify-start hover:text-everPurple8 transition-colors hover:bg-global-color/b/9 hover:bg-opacity-0.45 h-9", 
                    _ctx.locale === langItem.value
                      ? 'text-everBlack2'
                      : 'text-everGray3'
                  ]),
                          onClick: _withModifiers(($event: any) => (_ctx.changeLocale(langItem.value)), ["stop"])
                        }, [
                          _createElementVNode("span", null, _toDisplayString(langItem.label), 1)
                        ], 10, _hoisted_12))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 34),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex items-center justify-center whitespace-nowrap", 
              _ctx.btnStyleType === 'primary'
                ? `text-sm px-3 leading-8 h-8 cursor-pointer text-white connect-btn ${_ctx.navbarBtnBackClass}`
                : `text-sm px-3 leading-9 h-9 box-border border border-solid rounded-lg cursor-pointer ${_ctx.navbarBtnBorderClass} ${_ctx.navbarTextColorClass}`
            ]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('handleBtnClick')))
          }, _toDisplayString(_ctx.btnText), 3)
        ]),
        _createElementVNode("div", {
          class: "ml-2.5 rounded w-8 h-8 flex flex-row items-center justify-center cursor-pointer lg:hidden bg-everWhite4",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mobileNavModalOpened = !_ctx.mobileNavModalOpened))
        }, [
          _createElementVNode("img", {
            class: "w-4 h-4 block",
            src: 
              require(`@/images/${
                _ctx.mobileNavModalOpened ? 'close' : 'menu'
              }.svg`)
            
          }, null, 8, _hoisted_15)
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: "fixed top-16 left-0 w-full h-screen bg-graypurple/gp-3-normal z-20 bg-opacity-20",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeMobileNavModal && _ctx.closeMobileNavModal(...args)))
              }),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item, index) => {
                  return (_openBlock(), _createBlock(_component_MobileNavItem, {
                    key: index,
                    "nav-item": item,
                    current: index,
                    "is-current-click": _ctx.currentClick === index,
                    onCloseMobileModal: _ctx.closeMobileNavModal
                  }, null, 8, ["nav-item", "current", "is-current-click", "onCloseMobileModal"]))
                }), 128)),
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems2, (item, index) => {
                  return (_openBlock(), _createBlock(_component_MobileNavItem, {
                    key: index,
                    "nav-item": item,
                    current: index,
                    "is-current-click": _ctx.currentClick === index,
                    onCloseMobileModal: _ctx.closeMobileNavModal
                  }, null, 8, ["nav-item", "current", "is-current-click", "onCloseMobileModal"]))
                }), 128))
              ])
            ], 512), [
              [_vShow, _ctx.mobileNavModalOpened]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}